// extracted by mini-css-extract-plugin
module.exports = {"colorPrimary":"#328277"};